import React from 'react';
import '../styles/ChatIcon.css';
import { colour } from '../styles/GlobalStyles';
import { IconButton } from './';
import { HugeiconsIcon } from '@hugeicons/react';
import { BubbleChatQuestionIcon } from '@hugeicons/core-free-icons';

function ChatIcon(props) {
    const hoverEffect = props.hoverEffect;
    const toggleClick = props.toggleClick;
    const expanded = props.expanded;
    const setExpanded = props.setExpanded;
    const hoverText = props.hoverText;

    const expandIcon = () => {
        if ( hoverEffect === false ) {
            return;
        }
        setExpanded(true);
    };

    const collapseIcon = () => {
        if ( hoverEffect === false ) {
            return;
        }
        setExpanded(false);
    };

    return (
        <div 
            className={"chat-icon-container cursor-pointer " + (expanded === true ? "chat-icon-expanded" : "")}
            onMouseEnter={expandIcon}
            onMouseLeave={collapseIcon}
            onClick={() => toggleClick()}
        >
            <span className="body-regular colour-primary chat-icon-text">
                {hoverText}
            </span>
            <IconButton
                size="large"
                icon={<HugeiconsIcon icon={BubbleChatQuestionIcon} color={colour.gray00} size={21} />}
                disabled={false}
                clickFunc={() => null}
                standardIcon={false}
                background={true}
                bgType={"dark"}
                contextTooltip={false}
                contextTooltipBG={null}
                contextTooltipText={null}
                customClass={null}
            />
        </div>
    );
}

export default ChatIcon;